import React from 'react';
import {
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Grid,
  TextField,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import {
  renderDropdown,
  renderDropdownWithoutLabel,
} from '../../../../common/inputField';

const PatientDetails = ({ keyPath }) => {
  const dispatch = useDispatch();
  const patientDetails = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );

  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );

  const handleChange = (key, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
  };

  const handleDropdownChange = (e, index, name) => {
    const { value } = e.target;
    handleChange(name, value);
  };

  return (
    <Paper className="p-3 mb-3">
      <Typography variant="h6" gutterBottom>
        Patient Details
      </Typography>
      <Grid container spacing={2}>
        {/* {Object.entries(patientDetails).map(([key, value], index) => ( */}
        <Grid item xs={12} sm={12}>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  {/* Fixed width for labels */}
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Patient Name
                  </TableCell>
                  {/* Align values to the start of the cell */}
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={
                        selectedPatientData.patient.partner.firstName +
                        ' ' +
                        selectedPatientData.patient.partner.lastName
                      }
                      disabled
                      fullWidth
                    />
                  </TableCell>
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Spouse Name
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={
                        selectedPatientData.patient.firstName +
                        ' ' +
                        selectedPatientData.patient.lastName
                      }
                      disabled
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* Fixed width for labels */}
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Patient Age
                  </TableCell>
                  {/* Align values to the start of the cell */}
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={selectedPatientData.patient.partner.age}
                      disabled
                      fullWidth
                    />
                  </TableCell>
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Spouse Age
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={selectedPatientData.patient.age}
                      disabled
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* Fixed width for labels */}
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    MPID
                  </TableCell>
                  {/* Align values to the start of the cell */}
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={selectedPatientData.patient.upid}
                      disabled
                      fullWidth
                    />
                  </TableCell>
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Spouse MPID
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={selectedPatientData.patient.upid}
                      disabled
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* Fixed width for labels */}
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Referred By
                  </TableCell>
                  {/* Align values to the start of the cell */}
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={
                        selectedPatientData.patient.referral.referringPhysician
                      }
                      disabled
                      fullWidth
                    />
                  </TableCell>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    No. of days Abstinence
                  </TableCell>
                  {/* Align values to the start of the cell */}
                  <TableCell align="left">
                    <TextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="custom-text-field"
                      value={patientDetails.abstinenceDays}
                      onChange={(e) =>
                        handleChange('abstinenceDays', e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  {/* Fixed width for labels */}
                  <TableCell
                    style={{ width: '200px', fontWeight: 'bold' }}
                    align="left"
                  >
                    Date
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      type="date"
                      className="custom-text-field"
                      name="date"
                      value={patientDetails.date}
                      onChange={(e) => handleChange('date', e.target.value)}
                      fullWidth
                    />
                  </TableCell>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Collected At Lab
                  </TableCell>

                  <TableCell align="left">
                    {renderDropdownWithoutLabel(
                      'collectedAtLab',
                      patientDetails.collectedAtLab,
                      ['Yes', 'No'],
                      handleDropdownChange,
                    )}
                  </TableCell>
                </TableRow>
                <TableRow></TableRow>

                <TableRow>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Sample
                  </TableCell>

                  <TableCell align="left">
                    {renderDropdownWithoutLabel(
                      'sample',
                      patientDetails.sample,
                      ['Complete', 'Incomplete'],
                      handleDropdownChange,
                    )}
                  </TableCell>

                  {keyPath.startsWith('sfr') && (
                    <>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        Source of Sperm
                      </TableCell>
                      <TableCell align="left">
                        {renderDropdownWithoutLabel(
                          'sourceOfSperm',
                          patientDetails.sourceOfSperm,
                          ['Ejaculate', 'Surgical Sperm Retrieval', 'Other'],
                          handleDropdownChange,
                        )}
                        {patientDetails.sourceOfSperm === 'Other' && (
                          <TextField
                            className="custom-text-field"
                            value={patientDetails.sourceOfSpermOther}
                            onChange={(e) =>
                              handleChange('sourceOfSpermOther', e.target.value)
                            }
                            fullWidth
                          />
                        )}
                      </TableCell>
                    </>
                  )}

                  {keyPath.startsWith('iui') && (
                    <>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        Source of Sample
                      </TableCell>
                      <TableCell align="left">
                        {renderDropdownWithoutLabel(
                          'sourceOfSample',
                          patientDetails.sourceOfSample,
                          ['Self', 'Donor'],
                          handleDropdownChange,
                        )}
                        {patientDetails.sourceOfSample === 'Self' &&
                          renderDropdownWithoutLabel(
                            'sourceOfSampleSelf',
                            patientDetails.sourceOfSampleSelf,
                            ['Fresh', 'Frozen', 'Other'],
                            handleDropdownChange,
                          )}
                        {patientDetails.sourceOfSample === 'Self' &&
                          patientDetails.sourceOfSampleSelf === 'Other' && (
                            <TextField
                              className="custom-text-field"
                              value={patientDetails.sourceOfSampleSelfOther}
                              onChange={(e) =>
                                handleChange(
                                  'sourceOfSampleSelfOther',
                                  e.target.value,
                                )
                              }
                              fullWidth
                            />
                          )}
                        {patientDetails.sourceOfSample === 'Donor' && (
                          <>
                            <TextField
                              label="Donor Bank"
                              className="custom-text-field"
                              value={patientDetails.sourceOfSampleDonorBank}
                              onChange={(e) =>
                                handleChange(
                                  'sourceOfSampleDonorBank',
                                  e.target.value,
                                )
                              }
                              fullWidth
                            />
                            <TextField
                              label="Donor Code"
                              className="custom-text-field"
                              value={patientDetails.sourceOfSampleDonorCode}
                              onChange={(e) =>
                                handleChange(
                                  'sourceOfSampleDonorCode',
                                  e.target.value,
                                )
                              }
                              fullWidth
                            />
                          </>
                        )}
                      </TableCell>
                    </>
                  )}
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Sample Received By
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={patientDetails.sampleReceivedBy}
                      onChange={(e) =>
                        handleChange('sampleReceivedBy', e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Witness
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={patientDetails.sampleReceivedByWitness}
                      onChange={(e) =>
                        handleChange('sampleReceivedByWitness', e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Sample Processed By
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={patientDetails.sampleProcessedBy}
                      onChange={(e) =>
                        handleChange('sampleProcessedBy', e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                  <TableCell align="left" style={{ fontWeight: 'bold' }}>
                    Witness
                  </TableCell>
                  <TableCell align="left">
                    <TextField
                      className="custom-text-field"
                      value={patientDetails.sampleProcessedByWitness}
                      onChange={(e) =>
                        handleChange('sampleProcessedByWitness', e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {/* ))} */}
      </Grid>
    </Paper>
  );
};

export default PatientDetails;
